<ng-template #ReceiptHeader>
	<!-- Receipt-Header -->
	<div class="grid-1-auto app-space-top" *ngIf="!workspace.isLoading">
		<h2 class="app-space-left">
			<i [ngClass]="getRessource('ReceiptIcon')"
			   class="app-space-right">
			</i>
			{{getGlobal('ReceiptStatement')}}
			<br>
		</h2>
		<div class="typo-small typo-right app-space-right">
			<em>
				{{enumSvc.getEnumerationText('ReceiptStatus', workspace.receiptData.rcpt_enmIdent_ReceiptStatus)}}
			</em>
		</div>
	</div>
</ng-template>
<ng-template #LoadingSpinner>
	<i class="far fa-spinner-third fa-spin app-space-right" *ngIf="workspace.isLoadingPreview"></i>
</ng-template>
<div class="content grid-1-auto md3-surface">
	<div class="content md3-card-on-surface">
		<app-exc-pdfviewer-v3 *ngIf="!workspace.hideViewer"
		                      [docPath]="workspace.receiptData && !workspace.receiptData.rcpt_fileStreamID ? '' : viewerurl"
		                      [docID]="'statement-' + workspace.receiptData.rcptID"
		                      [docName]="workspace.receiptData.rcptFileName"
		                      [docAnnotations]="workspace.receiptData.AggrAnnotation"

		                      [showAnnotationToolbar]="true"
		                      [canShowAnnotationToolbar]="(
			                      VCrightTabControl._selectedtab !== 0
		                      ) && securityHandler.canEdit()"

		                      (viewerDocumentLoaded)="receiptPDFViewer.onDocumentLoaded()"
		                      (viewerPageClicked)="receiptPDFViewer.pageClicked()"
		                      (ready)="receiptPDFViewer.onViewerReady()"

		                      (annotationAdded)="receiptPDFViewer.annotationAdded($event)"
		                      (annotationDeleted)="receiptPDFViewer.annotationDeleted($event)"
		                      (annotationPropertiesChanged)="receiptPDFViewer.annotationChanged($event)"
		                      (annotationChanged) = "receiptPDFViewer.annotationChanged($event)"
		                      (annotationUnselected)="receiptPDFViewer.annotationUnselected($event)"
		                      (annotationSelected)="receiptPDFViewer.annotationSelected($event)"

		                      (annotationModeChanged)="receiptPDFViewer.annotationModeChanged($event)"

		                      (signatureSelect)="receiptPDFViewer.signatureSelect($event)"
		                      (signatureUnSelect)="receiptPDFViewer.signatureUnSelect($event)"

		                      [showOnlyStamps]="false"
                          [userStempel]="userSettingsSvc.stempel"

		                      [hidden]="!workspace.receiptData || (workspace.receiptData && !workspace.receiptData.rcpt_fileStreamID)">
		</app-exc-pdfviewer-v3>
		<div *ngIf="workspace.receiptData && !workspace.receiptData.rcpt_fileStreamID">
			<div class="splash empty">
				<p>{{getRessource('NoFileData')}}</p>
			</div>
		</div>
	</div>
	<div class="content md3-card-on-surface">
		<div class="app-layout-frame-drawer" style="width: 660px" #DivDrawer>
			<div class="content">
				<app-exg-tab-v2 #VCrightTabControl (tabchange)="rightTabs_tabChange($event)"
				                [header]="rightTabs"  [hidden]="workspace.isLoading">
					<ng-template #pages>
						<!-- 1 - Details-->
						<div class="content">
							<div class="layout-1-auto">
								<div class="content layout-auto-1">
									<ng-container *ngTemplateOutlet="ReceiptHeader"></ng-container>
									<app-receipt-statement-details #VCreceipt
									                               *ngIf="!workspace.isLoading"
									                               [workspace]="workspace"
									                               [details]="details"
									                               [checkview]="this"
									                               [canEdit]="securityHandler.canEdit()">
									</app-receipt-statement-details>
								</div>
								<!-- Review Buttons -->
								<div class="spawn-reverse typo-small">
									<ng-container *ngIf="!VCreceipt?.statementEditMode">
										<button (click)="receiptShowPreviewModal()"
										        class="md-btn" [disabled]="workspace.isLoadingPreview">
											<ng-container *ngTemplateOutlet="LoadingSpinner"></ng-container> {{getRessource('preview')}}
										</button>
										<button (click)="receiptReviewU_RevokeState(getRessource(isOneOf(workspace.receiptData.rcpt_enmIdent_ReceiptStatus, [10,20]) ? 'revokeAgain' : 'revoke'))"
										        *ngIf="workspace.receiptData && workspace.receiptData.rcpt_enmIdent_ReceiptStatus &&
					                          ((isOneOf(workspace.receiptData.rcpt_enmIdent_ReceiptStatus, [3,10,20]) && securityHandler.powerUser())
					                           || (isOneOf(workspace.receiptData.rcpt_enmIdent_ReceiptStatus, [3]) && !securityHandler.powerUser()))"
										        class="md-btn">
											{{getRessource(isOneOf(workspace.receiptData.rcpt_enmIdent_ReceiptStatus, [10,20]) ? 'revokeAgain' : 'revoke')}}
										</button>
										<button (click)="pickReview()"
										        [class.disabled]="!securityHandler.canPick()"
										        *ngIf="securityHandler.canPick()"
										        class="md-btn">
											{{getRessource('Pick')}}
										</button>
										<ng-container #SV *ngIf="isOneOf(workspace.receiptData.rcpt_enmIdent_ReceiptStatus, [0,1,2,5])">
											<button (click)="receiptReview(getRessource('review.proofIt'), true, undefined)"
											        class="md-btn">
												{{getRessource('review.proofIt')}}
											</button>
										</ng-container>
										<ng-container #IIS *ngIf="excSecurity.isFeatured('STATEMENTCHECK') && workspace.receiptData.rcpt_enmIdent_ReceiptStatus === 4">
											<button (click)="receiptReview(getRessource('review.toSV'), true, undefined)"
											        class="md-btn">
												{{getRessource('review.toSV')}}
											</button>
											<button (click)="receiptReview(getRessource('review.cancel'), true, false)"
											        class="md-btn app-space-left"
											>
												{{getRessource('review.cancel')}}
											</button>
											<button (click)="receiptReview(getRessource('review.accept'), true, true)"
											        class="md-btn"
											>
												{{getRessource('review.accept')}}
											</button>
										</ng-container>
									</ng-container>
								</div>
							</div>
						</div>
						<!-- 2- Notes-->
						<div class="content">
							<div [hidden]="workspace.isLoading" class="app-layout-annoation-notes app-space-left">
								<ng-container *ngTemplateOutlet="ReceiptHeader"></ng-container>
								<div class="app-space-top app-space-bottom ">
									<app-annotation-text #VCTextAnnotation
									                     [note]="receiptNoteTable.selectedRow"
									                     [hidden]="visibilityController.note">
									</app-annotation-text>
								</div>
								<div class="search-filter-seperator"></div>
								<!-- Notes-->
								<div class="content app-subarea">
									<exg-data-list  #VCreceiptNoteTable
									                (RowChange)="receiptNoteTable.selectionChanged($event)"
									                (dblclick)="visibilityController.noteSwitch(VCreceiptNoteTable.selectedRow === -1 || !securityHandler.canEdit())"
									                [displayState]="receiptNoteTable.state"
									                [rowSource]="receiptNoteTable.data"
									                [selectKey]="receiptNoteTable.selectKey"
									                [allowSingleSelection]="true">
										<ng-template #rowTemplate let-row>
											<div class="list-row list-row-1-auto app-list typo-small">
												<div>
													<p>
														{{row.rcptNtsNote}}
													</p>
												</div>
												<div class="typo-right">
													<div class="list-metadata">{{row.rcptAnnoCRD | excDate}}, {{row.rcptAnnoCRU}}</div>
												</div>
											</div>
										</ng-template>
									</exg-data-list>
								</div>
							</div>
						</div>
					</ng-template>
				</app-exg-tab-v2>
				<!-- loading Drawer -->
				<div *ngIf="workspace.isLoading" class="splash loading">
					<div class="spinner">
						<div></div>
						<div></div>
						<div></div>
						<div></div>
					</div>
				</div>
			</div>
			<!-- Right Quickactions -->
			<div class="app-drawer">
				<i class="disabled search-filter-action"></i>
				<i class="search-filter-seperator"></i>
				<ng-container *ngIf="!workspace.isLoading">
					<!-- Quickactions - 1 -->
					<ng-container *ngIf="VCreceipt && VCrightTabControl?.selectedtab === 0">
						<ng-container *ngIf="VCrightTabControl?.selectedtab === 0">
							<ng-container *ngIf="!VCreceipt?.statementEditMode">
								<i (click)="VCreceipt?.switchEditMode(this.securityHandler.canEdit())"
								   [class.disabled]="!securityHandler.canEdit()" [tooltip]="getGlobal('Edit')"
								   class="search-filter-action fal fa-edit" flow="left">
								</i>
							</ng-container>
							<ng-container *ngIf="VCreceipt?.statementEditMode">
								<i (click)="showMessageSureAbout()"
								   [tooltip]="getGlobal('Cancel')"
								   class="search-filter-action fal fa-window-close" flow="left">
								</i>
								<i (click)="saveReceipt(false)"
								   [class.disabled]="!VCreceipt?.statementChanged || workspace.isLoading"
								   [tooltip]="getGlobal('Save')"
								   class="search-filter-action fal fa-save" flow="left">
								</i>
								<i class="search-filter-seperator"></i>
							</ng-container>
						</ng-container>
						<ng-container *ngIf="!VCreceipt?.statementEditMode">
							<!-- Quickactions -->
							<i class="fal fa-fw fa-comments search-filter-action"
							   [class.disabled]="!(workspace.isLoading || workspace)"
							   (click)="receiptOpenMessageModal()"
							   [tooltip]="getRessource('Tooltip.Messages')" flow="left">
								<i *ngIf="getCommentaryLength > 0" style="font-size: 1.25rem; top: -26px"
								   class="fa-badge" [attr.data-badge]="getCommentaryLength"></i>
							</i>
							<i class="search-filter-seperator"></i>
							<i class="search-filter-action fal"
							   [class.fa-file-import]="workspace.receiptData.rcpt_fileStreamID"
							   [class.fa-file-circle-plus]="!workspace.receiptData.rcpt_fileStreamID"
							   [class.disabled]="!securityHandler.canEdit()"
							   (click)="OpenFileReplaceModal()"
							   [tooltip]="workspace.receiptData.rcpt_fileStreamID ? getRessource('Tooltip.Replace') : getRessource('Tooltip.AddFile')" flow="left">
							</i>
							<i class="search-filter-action fal fa-file-circle-plus"
							   [class.disabled]="!securityHandler.canEdit() || !workspace.receiptData.rcpt_fileStreamID"
							   (click)="OpenFileAddModal()"
							   [tooltip]="getRessource('Tooltip.AddFiles')"
							   flow="left">
							</i>
							<i class="search-filter-action fal fa-file-minus"
							   [class.disabled]="!securityHandler.canEdit() || !workspace.receiptData.rcpt_fileStreamID"
							   (click)="deleteReceiptFile()"
							   [tooltip]="getRessource('Tooltip.DeleteFile')"
							   flow="left">
							</i>
							<i class="search-filter-seperator"></i>
							<i class="fal fa-clipboard search-filter-action"
							   (click)="openWorkspace()"
							   [tooltip]="getRessource('Tooltip.openTaskWorkspace')"
							   flow="left"></i>
							<i class="search-filter-seperator"></i>
						</ng-container>
					</ng-container>

					<!-- Quickactions - Notizen -->
					<ng-container *ngIf="VCrightTabControl?.selectedtab === 1">
						<ng-container *ngIf="!visibilityController.note">
							<i (click)="receiptNote(true)"
							   [tooltip]="getGlobal('Cancel')"
							   class="search-filter-action fal fa-window-close" flow="left">
							</i>
							<i (click)="receiptNote()"
							   [tooltip]="getGlobal('Save')"
							   class="search-filter-action fal fa-save" flow="left">
							</i>
						</ng-container>
						<ng-container *ngIf="visibilityController.note">
							<i (click)="visibilityController.noteSwitch(VCreceiptNoteTable.selectedRow === -1 || !securityHandler.canEdit())"
							   [class.disabled]="VCreceiptNoteTable.selectedRow === -1 || !securityHandler.canEdit()"
							   [tooltip]="getGlobal('Edit')"
							   class="search-filter-action fal fa-edit" flow="left">
							</i>
							<i (click)="deleteNote()"
							   [class.disabled]="VCreceiptNoteTable.selectedRow === -1 || !securityHandler.canEdit()"
							   [tooltip]="getGlobal('Delete')"
							   class="search-filter-action fal fa-trash-alt" flow="left">
							</i>
							<!-- #AnnotationModes -->
						</ng-container>
						<i class="search-filter-seperator"></i>
					</ng-container>
				</ng-container>
			</div>
		</div>
	</div>
</div>
